import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';
import Card from './Card';
import { FaQuoteLeft } from 'react-icons/fa';

const TestimonialCard = ({ quote, name, role, company, image, className = '' }) => {
  return (
    <motion.div {...fadeIn}>
      <Card className={`${className}`} hover={false}>
        <FaQuoteLeft className="text-primary-blue text-3xl mb-4 opacity-50" />
        <p className="text-gray-700 mb-6 leading-relaxed italic">"{quote}"</p>
        <div className="flex items-center">
          <div className="w-12 h-12 rounded-full bg-gradient-primary flex items-center justify-center text-white font-bold text-lg mr-4">
            {name.charAt(0)}
          </div>
          <div>
            <h4 className="font-bold text-gray-900">{name}</h4>
            <p className="text-sm text-gray-600">{role}</p>
          </div>
        </div>
      </Card>
    </motion.div>
  );
};

export default TestimonialCard;
